import { useContext } from "react";
import { ImperativeDialogContext } from "@repo/ui";
import type { TaskManagerDTO } from "~/types/api-custom";
import { TaskDialog } from "./task-dialog";

export const useTaskDialog = () => {
  const dialogContext = useContext(ImperativeDialogContext);
  const { closeDialog, showDialog } = dialogContext ?? {};

  const showTaskDialog = (task?: TaskManagerDTO) => {
    const handleCloseRef = { current: () => closeDialog?.() };

    showDialog?.({
      content: <TaskDialog task={task} onClose={() => handleCloseRef.current()} />,
      onClose: () => {
        handleCloseRef.current();
      },
    });
  };

  return { showTaskDialog, closeDialog };
};
